import { PolicyTemplate, PolicyTemplateDetails } from '../../../../types/policies';
import { usePost, UsePostParams } from '../../../../api';
import { TEMPLATES_BASE_URL } from '../consts';

export type UseCreatePolicyTemplateParams = UsePostParams<PolicyTemplateDetails, PolicyTemplate>;

export const useCreatePolicyTemplate = (params: UseCreatePolicyTemplateParams) => {
    const { post, ...rest } = usePost<PolicyTemplateDetails, PolicyTemplate>(params);

    const createPolicyTemplate = (details: PolicyTemplateDetails) => post(TEMPLATES_BASE_URL, details);

    return {
        ...rest,
        createPolicyTemplate
    };
};
